import { render, staticRenderFns } from "./card-tabs.vue?vue&type=template&id=6c87956c"
import script from "./card-tabs.vue?vue&type=script&lang=js"
export * from "./card-tabs.vue?vue&type=script&lang=js"
import style0 from "./card-tabs.vue?vue&type=style&index=0&id=6c87956c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports